import React, { useId } from 'react'
import PropTypes from 'prop-types'

const SunIcon = React.forwardRef(function SunIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 7C9.23858 7 7 9.23858 7 12 7 14.7614 9.23858 17 12 17 14.7614 17 17 14.7614 17 12 17 9.23858 14.7614 7 12 7ZM5 12C5 8.13401 8.13401 5 12 5 15.866 5 19 8.13401 19 12 19 15.866 15.866 19 12 19 8.13401 19 5 15.866 5 12ZM12 0C12.5523 0 13 .447715 13 1V2C13 2.55228 12.5523 3 12 3 11.4477 3 11 2.55228 11 2V1C11 .447715 11.4477 0 12 0ZM12 21C12.5523 21 13 21.4477 13 22V23C13 23.5523 12.5523 24 12 24 11.4477 24 11 23.5523 11 23V22C11 21.4477 11.4477 21 12 21ZM20.4871 3.51286C20.8776 3.90339 20.8776 4.53655 20.4871 4.92708L19.3671 6.04708C18.9766 6.4376 18.3434 6.4376 17.9529 6.04708 17.5624 5.65655 17.5624 5.02339 17.9529 4.63286L19.0729 3.51286C19.4634 3.12234 20.0966 3.12234 20.4871 3.51286ZM6.04711 17.9529C6.43763 18.3434 6.43763 18.9766 6.04711 19.3671L4.92711 20.4871C4.53658 20.8776 3.90342 20.8776 3.51289 20.4871 3.12237 20.0966 3.12237 19.4634 3.51289 19.0729L4.63289 17.9529C5.02342 17.5623 5.65658 17.5623 6.04711 17.9529ZM21 12C21 11.4477 21.4477 11 22 11H23C23.5523 11 24 11.4477 24 12 24 12.5523 23.5523 13 23 13H22C21.4477 13 21 12.5523 21 12ZM0 12C0 11.4477.447715 11 1 11H2C2.55228 11 3 11.4477 3 12 3 12.5523 2.55228 13 2 13H1C.447715 13 0 12.5523 0 12ZM17.9529 17.9529C18.3434 17.5623 18.9766 17.5623 19.3671 17.9529L20.4871 19.0729C20.8776 19.4634 20.8776 20.0966 20.4871 20.4871 20.0966 20.8776 19.4634 20.8776 19.0729 20.4871L17.9529 19.3671C17.5624 18.9766 17.5624 18.3434 17.9529 17.9529ZM3.51289 3.51286C3.90342 3.12234 4.53658 3.12234 4.92711 3.51286L6.04711 4.63286C6.43763 5.02339 6.43763 5.65655 6.04711 6.04708 5.65658 6.4376 5.02342 6.4376 4.63289 6.04708L3.51289 4.92708C3.12237 4.53655 3.12237 3.90339 3.51289 3.51286Z"
        ></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

SunIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SunIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default SunIcon
